import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Collapse,
  Container,
  Input,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import TableContainer from "../../Components/Common/TableContainer";

import Loader from "../../Components/Common/Loader";

import { adminGetAllWorkLocation } from "helpers/backend_helpers";
import { formatDateTime } from "helpers/globalFunction";
import UpdateModalWorkLocation from "./UpdateModalWorkLocation";
import DeleteModalWorkLocation from "./DeleteModalWorkLocation";
import AddModalWorkLocation from "./AddModalWorkLocation";

const WorkLocation = () => {
  const [tableData, setTableData] = useState<any>([]);
  const [data, setData] = useState<any>({});
  const [sort, setSort] = useState("createTime");
  const [dir, setDir] = useState(-1);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [rowCount, setRowCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [addModal, setAddModal] = useState<boolean>(false);
  const [updateModal, setUpdateModal] = useState<boolean>(false);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);

  const [showFilter, setShowFilter] = useState<boolean>(false);
  const [filterName, setFilterName] = useState<string>("");
  const [searchName, setSearchName] = useState<string>("");

  useEffect(() => {
    const timer = setTimeout(() => {
      setSearchName(filterName);
    }, 500);

    return () => {
      clearTimeout(timer);
    };
  }, [filterName]);

  const getData = () => {
    setLoading(true);
    let query: any = {
      page: pagination.pageIndex,
      size: pagination.pageSize,
      sort: sort,
      dir: dir,
    };

    if (searchName) {
      query.name = searchName;
    }

    adminGetAllWorkLocation(query)
      .then((response: any) => {
        setTableData(
          response.content.map((el: any, index: any) => {
            let dibuat = formatDateTime(el.createTime);
            let diperbarui = formatDateTime(el.updateTime);
            return {
              ...el,
              index: index + pagination.pageIndex * pagination.pageSize + 1,
              dibuat,
              diperbarui,
            };
          })
        );
        setRowCount(response.totalElements);
        setTotalPages(response.totalPages);
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
      });
  };

  const handleResetFilter = () => {
    setFilterName("");
    setSearchName("");
  };

  const handleToggleFilter = () => {
    if (showFilter) {
      handleResetFilter();
    }
    setShowFilter(!showFilter);
  };

  const columns = useMemo(
    () => [
      {
        header: "#",
        accessorKey: "index",
        enableColumnFilter: false,
        enableSorting: false,
        size: 50,
      },
      {
        header: "Lokasi Kerja",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: false,
        size: 150,
      },
      {
        header: "Alamat",
        accessorKey: "address",
        enableColumnFilter: false,
        enableSorting: false,
        size: 150,
      },
      {
        header: "Latitude",
        accessorKey: "lat",
        enableColumnFilter: false,
        enableSorting: false,
        size: 150,
      },
      {
        header: "Longitude",
        accessorKey: "lon",
        enableColumnFilter: false,
        enableSorting: false,
        size: 150,
      },
      {
        header: "Dibuat",
        accessorKey: "dibuat",
        enableColumnFilter: false,
        enableSorting: false,
        size: 150,
      },
      {
        header: "Diperbarui",
        accessorKey: "diperbarui",
        enableColumnFilter: false,
        enableSorting: false,
        size: 150,
      },
      {
        header: "Aksi",
        enableColumnFilter: false,
        enableSorting: false,
        size: 250,
        cell: (cellProps: any) => {
          return (
            <div className="hstack gap-2">
              <button
                className="btn btn-sm btn-soft-warning edit-list"
                title="Edit"
                onClick={() => {
                  setUpdateModal(true);
                  setData(cellProps.row.original);
                }}
              >
                <i className="ri-pencil-fill align-bottom" />
              </button>

              <button
                className="btn btn-sm btn-soft-danger remove-list"
                title="Hapus"
                onClick={() => {
                  setDeleteModal(true);
                  setData(cellProps.row.original);
                }}
              >
                <i className="ri-delete-bin-5-fill align-bottom" />
              </button>
            </div>
          );
        },
      },
    ],
    []
  );

  useEffect(() => {
    getData();
  }, [pagination, sort, dir, searchName]);

  document.title = "Lokasi Kerja";

  return (
    <React.Fragment>
      <div className="page-content">
        <AddModalWorkLocation
          show={addModal}
          onCloseClick={() => setAddModal(false)}
          getData={() => getData()}
        />

        <UpdateModalWorkLocation
          show={updateModal}
          onCloseClick={() => setUpdateModal(false)}
          getData={() => getData()}
          data={data}
        />

        <DeleteModalWorkLocation
          show={deleteModal}
          onCloseClick={() => setDeleteModal(false)}
          getData={() => getData()}
          data={data}
          setData={() => setData({})}
        />

        <Container fluid>
          <BreadCrumb title="Lokasi Kerja" pageTitle="Lokasi Kerja" />

          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader className="border-0">
                  <div className="d-flex align-items-center">
                    <h5 className="card-title mb-0 flex-grow-1">
                      Lokasi Kerja
                    </h5>
                    <div className="flex-shrink-0">
                      <div className="d-flex gap-2 flex-wrap">
                        <button
                          className="btn btn-soft-primary btn-sm"
                          onClick={handleToggleFilter}
                        >
                          <i className="ri-filter-3-line align-bottom me-1"></i>
                          Filters
                        </button>
                        <div
                          className="btn btn-soft-success btn-sm"
                          onClick={() => {
                            setAddModal(true);
                          }}
                        >
                          <i className="ri-add-line align-bottom me-1"></i>{" "}
                          Tambah
                        </div>
                      </div>
                    </div>
                  </div>
                </CardHeader>
                <CardBody className="pt-0">
                  <Collapse isOpen={showFilter}>
                    <Row className="g-3 mb-4">
                      <Col lg={4}>
                        <div>
                          <Input
                            type="text"
                            className="form-control"
                            placeholder="Cari lokasi kerja..."
                            value={filterName}
                            onChange={(e) => setFilterName(e.target.value)}
                          />
                        </div>
                      </Col>
                      <Col lg={12}>
                        <div className="d-flex gap-2">
                          <button
                            className="btn btn-soft-secondary btn-sm"
                            onClick={handleResetFilter}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>
                            Reset
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </Collapse>
                  <div>
                    {loading ? (
                      <Loader />
                    ) : (
                      <TableContainer
                        columns={columns}
                        data={tableData || []}
                        customPageSize={10}
                        theadClass="text-muted text-uppercase"
                        manualPagination
                        pagination={pagination}
                        pageCount={totalPages}
                        onPaginationChange={setPagination}
                        divClass="table-responsive"
                      />
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default WorkLocation;
